import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Mail = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve0" d="M1280 1920l7680 0c353,0 640,287 640,640l0 5120c0,353 -287,640 -640,640l-7680 0c-353,0 -640,-287 -640,-640l0 -5120c0,-353 287,-640 640,-640zm7680 937l-3663 3397c-123,115 -313,113 -435,0l-3582 -3391 0 4497 2318 -1862 197 186 -2195 1996 7040 0 -2227 -2024 197 -183 2350 1887 0 -4503zm-7315 -297l3475 2880 3475 -2880 -6950 0z"/>
    </SvgIcon>
);
export default Mail;

